/**
 * The browser title for a page, as the layout sets it. A page naming its own
 * subject writes this when it has none, the layout writing only on a title
 * change — so between two subjects of one kind, nothing else puts it back.
 */
export const getPageTitle = (title?: string) =>
  title ? `${title} | Cognito Online` : 'Cognito Online';

// Returns true if there is a subpath of testPath in a list of paths
export const isInPaths = (paths: string[], testPath: string) => {
  // Remove initial slash from paths
  const truncatedPaths = paths.map(path => (path.startsWith('/') ? path.slice(1) : path));
  // Remove initial slash from testPath
  const truncatedTestPath = testPath.startsWith('/') ? testPath.slice(1) : testPath;

  const slashCount = (truncatedTestPath.match(/\//g) || []).length;
  let currSlashIndex = truncatedTestPath.indexOf('/', 0);
  if (currSlashIndex < 0) {
    currSlashIndex = truncatedTestPath.length;
  }
  for (let i = 0; i <= slashCount; i++) {
    if (truncatedPaths.includes(truncatedTestPath.slice(0, currSlashIndex))) {
      return true;
    }

    // Look for the next slash to continue searching down the path tree
    currSlashIndex = truncatedTestPath.indexOf('/', currSlashIndex + 1);
    if (currSlashIndex < 0) {
      currSlashIndex = truncatedTestPath.length;
    }
  }
  return false;
};
